<!--Search Options-->
<div class="SearchOptionsDiv">
	<h4>Search Fields:</h4>

	<div class="OptionGrid">
		<h4 class="FullWidth">Name/Alias</h4>

		<input [disabled]="IsLoading() == true" class="CHK" type="checkbox" [(ngModel)]="UseFirst" />
		<div class="SubOptionGrid">
			<label>First Name</label>
			<input [disabled]="IsLoading() == true" type="text" class="form-control" [(ngModel)]="FirstName" />
		</div>

		<input [disabled]="IsLoading() == true" class="CHK" type="checkbox" [(ngModel)]="UseLast" />
		<div class="SubOptionGrid">
			<label>Last Name</label>
			<input [disabled]="IsLoading() == true" type="text" class="form-control" [(ngModel)]="LastName" />
		</div>

		<input [disabled]="IsLoading() == true" class="CHK" type="checkbox" [(ngModel)]="UseAlias" />
		<div class="SubOptionGrid">
			<label>Alias</label>
			<input [disabled]="IsLoading() == true" type="text" class="form-control" [(ngModel)]="Alias" />
		</div>

		<h4 class="FullWidth">DOB</h4>

		<input [disabled]="IsLoading() == true" class="CHK" type="checkbox" [(ngModel)]="UseBirthDate" />
		<div class="SubOptionGrid">
			<label>Birth Date</label>
			<p-calendar
				[disabled]="IsLoading() == true"
				showIcon="true"
				showButtonBar="true"
				[(ngModel)]="BirthDate"
				name="BirthDate"
				appendTo="body"
			></p-calendar>
		</div>

		<input [disabled]="IsLoading() == true" class="CHK" type="checkbox" [(ngModel)]="UseBirthYear" />
		<div class="SubOptionGrid">
			<label>Birth Year</label>
			<input [disabled]="IsLoading() == true" type="text" class="form-control" [(ngModel)]="BirthYear" />
		</div>

		<h4 class="FullWidth">Location</h4>

		<!-- <input [disabled]="IsLoading() == true" class="CHK" type="checkbox" [(ngModel)]="UseLatLonDistance" />
		<div class="SubOptionGrid">
			<label>Lat</label>
			<input [disabled]="IsLoading() == true" type="text" class="form-control" [(ngModel)]="Lat" />

			<label>Lon</label>
			<input [disabled]="IsLoading() == true" type="text" class="form-control" [(ngModel)]="Lon" />

			<label>Distance</label>
			<input [disabled]="IsLoading() == true" type="text" class="form-control" [(ngModel)]="Distance" />
		</div> -->

		<input [disabled]="IsLoading() == true" class="CHK" type="checkbox" [(ngModel)]="UseZipCode" />
		<div class="SubOptionGrid">
			<label>Zip</label>
			<input [disabled]="IsLoading() == true" type="text" class="form-control" [(ngModel)]="ZipCode" />
		</div>

		<h4 class="FullWidth">Misc.</h4>

		<input [disabled]="IsLoading() == true" class="CHK" type="checkbox" [(ngModel)]="EnterManually" />
		<div class="SubOptionGrid">
			<label>Manually Enter Query</label>
			<textarea [disabled]="IsLoading() == true" class="TextArea" [(ngModel)]="ManualQuery" rows="5"></textarea>
		</div>
	</div>

	<div style="margin-top: 30px">
		<h4 class="FullWidth">Query Preview</h4>
		<p class="PreviewText">{{ GetQueryPreview() }}</p>
	</div>

	<div style="margin-top: 15px">
		<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onSearch()">Search</button>
	</div>
</div>

<!--Results-->
<div style="margin-top: 15px; padding: 15px">
	<h4>Results</h4>
	<div *ngIf="IsLoading() == true" class="alert alert-info">...Loading</div>

	<!--Gallery of Offender hits-->
	<div>
		<p-dataView
			#dv
			[value]="lstOffenders"
			[paginator]="true"
			paginatorPosition="both"
			[rows]="9"
			[sortField]="sortField"
			[sortOrder]="sortOrder"
			layout="grid"
			[showCurrentPageReport]="true"
			currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
		>
			<ng-template pTemplate="header">
				<div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between">
					<p-dropdown
						[disabled]="IsLoading() == true"
						[options]="sortOptions"
						[(ngModel)]="sortKey"
						placeholder="Sort By"
						(onChange)="onSortChange($event)"
						styleClass="p-mb-2 p-mb-md-0"
					></p-dropdown>
					<!-- <span class="p-input-icon-left p-mb-2 p-mb-md-0">
                        <i class="pi pi-search"></i>
                        <input type="search" pInputText placeholder="Search by Name" (input)="dv.filter($event.target.value)">
                    </span> -->
				</div>
			</ng-template>
			<ng-template let-Offender pTemplate="gridItem">
				<div class="GridItem">
					<div class="ItemBorder">
						<div class="ItemGrid">
							<!--Top, Image-->
							<div class="ImgDiv">
								<img class="ImgBorder" [src]="Offender.OffenderPhoto" alt="Offender #{{ Offender.OffenderID }}" />
							</div>

							<!--Middle, Data-->
							<div class="InfoColGrid">
								<label>First Name:</label>
								<p class="WrapText">{{ Offender.FirstName }}</p>

								<label>Last Name:</label>
								<p class="WrapText">{{ Offender.LastName }}</p>

								<label>DOB:</label>
								<p class="WrapText">{{ Offender.DOBDesc }}</p>

								<label>Offender Status:</label>
								<p class="WrapText">
									{{ Offender.OffenderStatus }}
								</p>

								<label>State:</label>
								<p class="WrapText">{{ Offender.State }}</p>

								<label>Conviction Place:</label>
								<p class="WrapText">
									{{ Offender.ConvictionPlace }}
								</p>

								<label>Race:</label>
								<p class="WrapText">{{ Offender.Race }}</p>

								<label>Sex:</label>
								<p class="WrapText">{{ Offender.Sex }}</p>

								<label>Height:</label>
								<p class="WrapText">{{ Offender.Height }}</p>

								<label>Weight:</label>
								<p class="WrapText">{{ Offender.Weight }}</p>

								<label>Hair Color:</label>
								<p class="WrapText">{{ Offender.HairColor }}</p>

								<label>Eye Color:</label>
								<p class="WrapText">{{ Offender.EyeColor }}</p>
							</div>
						</div>
					</div>
				</div>
			</ng-template>
		</p-dataView>
	</div>
</div>
